<template>
  <div :class="edit?'edit-main-form':'main-form'">
    <PageHeader :title="report.id?`報告書No. ${report.id}` : ''" class="list">
      <template #title-header-content>
        <div class="flex-1 flex justify-end items-center">
          <div class="text-white mx-auto">
            <!-- 写真に自動日付添付 -->
            <div v-if="autoDate&&!(onlyCameraBtn).includes(type)" class="text-xs">
              ※カメラ起動ボタン：自動で写真に日付が入ります
            </div>
            <div v-else-if="autoDate" class="text-xs">
              ※自動で写真に日付が入ります
            </div>
          </div>

          <!-- テンプレート1 -->
          <div v-if="[1, 2].includes(type)" class="mr-4">
            <PrimaryButton text="Template" size="font-bold bg-blue-500 border border-blue-800 rounded-md px-2 py-1.5 text-white cursor-pointer" :disabled="loading" @click="changeTemplate1()">
            </PrimaryButton>
          </div>

          <!-- 出力ボタン -->
          <div v-if="!template1" class="mr-4">
            <DropdownButton text="出力" size="font-bold text-white rounded normal px-10" :menus="downloadMenu" @select="downloadSelect">
              <LoadingIcon v-if="loading" slot="before" class="h-4 w-4" />
              <Icon v-if="!loading" iconName="Printer" slot="before" class="h-4 w-4" />
              <Icon iconName="ChevronDown" slot="after" class="h-4 w-4" />
            </DropdownButton>
          </div>

          <!-- PDF出力 -->
          <div v-if="template1" class="mr-4">
            <PrimaryButton text="PDF" size="font-bold border rounded-md text-white normal" :disabled="loading" @click="downloadSelect({ value: 2 })">
              <LoadingIcon v-if="loading" slot="before" class="h-4 w-4" />
              <Icon v-if="!loading" iconName="Printer" slot="before" class="h-4 w-4" />
            </PrimaryButton>
          </div>

          <!-- 戻る -->
          <div v-if="backBtn" class="min-w-fit">
            <PrimaryButton class="bg-green-600 mr-2" text="戻る" :disabled="loading" @click="previous()">
              <LoadingIcon v-if="loading" slot="before" class="h-4 w-4" />
              <Icon v-else iconName="Reply" slot="before" class="h-4 w-4" />
            </PrimaryButton>
          </div>

          <!-- 一覧 -->
          <div v-else class="min-w-fit">
            <PrimaryButton class="bg-green-600 mr-2" text="一覧" :disabled="loading" @click="toList()">
              <LoadingIcon v-if="loading" slot="before" class="h-4 w-4" />
              <Icon v-else iconName="ViewGrid" slot="before" class="h-4 w-4" />
            </PrimaryButton>
          </div>
        </div>
      </template>
      <template #page-header-content>
        <div class="flex justify-between -mt-2 mx-auto">

          <!-- 新規作成開始ボタン -->
          <div v-if="!report.id" class="max-w-2xl w-full mx-auto">
            <PrimaryButton text="作成開始" :disabled="loading" class="w-full" @click="start()">
            </PrimaryButton>
          </div>

          <div v-else-if="!cannotEdit" class="flex justify-between max-w-2xl w-full mx-auto">
            <!-- 編集ボタン -->
            <div class="w-full">
              <PrimaryButton text="編集" class="w-full max-w-md" :class="edit ? 'bg-gray-300 cursor-not-allowed border-gray-300' : ''" :disabled="edit || loading" @click="editBtn()">
                <LoadingIcon v-if="loading" slot="before" class="h-4 w-4" />
              </PrimaryButton>
            </div>

            <!-- 完了ボタン -->
            <div class="w-full mx-2">
              <PrimaryButton :text="sendChat?'完了（チャット送信）':'完了'" class="w-full max-w-md" :class="!edit ? 'bg-gray-300 cursor-not-allowed border-gray-300' : ''" :disabled="!edit || loading" @click="completeBtn()">
                <LoadingIcon v-if="loading" slot="before" class="h-4 w-4" />
              </PrimaryButton>
            </div>

            <!-- 写真・コメント欄追加ボタン -->
            <div v-if="edit && !template1" class="">
              <PrimaryButton text="項目追加" class="add-btn text-xs whitespace-nowrap" @click="addItem(true)">
                <Icon slot="before" iconName="PlusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
              </PrimaryButton>
            </div>
            <div v-else-if="template1" class="w-96">
              <PrimaryButton text="色・位置変更" class="color-btn" @click="changeColor()">
              </PrimaryButton>
            </div>
          </div>

          <!-- 編集不可の説明 -->
          <div v-if="cannotEdit" class="font-bold text-white mx-auto">
            <div v-if="editSameDay">作成者本人かつ本日分のみ編集可能</div>
            <div v-else-if="editSameMonth">作成者本人かつ今月分のみ編集可能</div>
            <div v-else-if="editSameUser">本人のみ編集可能</div>
          </div>

        </div>
      </template>
    </PageHeader>
    <main class="absolute w-full overflow-auto bg-white rounded" :class="[edit?'edit-main-form':'main-form', isMobileDevice ? '' : 'pc-h']" style="top: 115px; font-family: sans-serif;">
      <div v-if="!loadingFirst">
        <!-- 削除ボタン（ヘッダーだと完了ボタンの近くになって誤っておすので、左端に置いた） -->
        <div v-if="report.id&&!cannotEdit&&type!=7" class="m-1 w-20">
          <PrimaryButton text="削除" size="sm font-bold bg-red-700 border border-red-800 rounded-md px-2 py-1.5 text-white cursor-pointer" :disabled="loading" @click="deleteReport()">
          </PrimaryButton>
        </div>

        <!-- 操作説明 -->
        <div v-if="report.id&&!cannotEdit" class="w-fit mx-auto text-xs font-bold text-gray-600 mb-3 border p-2 rounded border-blue-300 bg-blue-50">
          <div v-if="!canNotChangeSortType.includes(type)">※「項目並替ボタン」をドラッグ＆ドロップで項目の並べ替え可能</div>
          <div>※「写真並替をON」の場合、写真をドラッグ＆ドロップで写真の入れ替え可能</div>
          <div>※写真を複数選択時に写真連続添付</div>
        </div>

        <div class="flex justify-end mx-auto mt-3" style="width: 730px;">
          <!-- ページの写真枚数 -->
          <div class="text-xs font-bold text-gray-500 mt-auto mx-5 flex" style="align-items: flex-end" v-if="user">
            ページの写真枚数：
            <div class="flex font-bold cursor-pointer">
              <div class="rounded-l px-2 py-1 text-xs text-white" :class="report.photosNumber==6?'bg-blue-600':'bg-gray-300'" @click="clickPhotosNumber(6)">
                ６枚
              </div>
              <div class="rounded-r px-2 py-1 text-xs text-white" :class="report.photosNumber==8?'bg-blue-600':'bg-gray-300'" @click="clickPhotosNumber(8)">
                ８枚
              </div>
            </div>
          </div>

          <!-- 最終更新者 -->
          <div class="text-xs font-bold text-gray-500 mt-auto mx-5" v-if="user">
            更新者：{{ user }}
          </div>

          <!-- 最終更新日 -->
          <div class="text-xs font-bold text-gray-500 mt-auto ml-5" v-if="updateDate">
            更新日：{{ updateDate }}
          </div>
        </div>
        <div class="flex justify-end mt-3">
          <!-- 予定日 -->
          <div class="text-sm font-bold mx-auto w-fit text-indigo-700" v-if="report&&report.scheduledDate">
            予定日：{{ report.scheduledDate }}
          </div>
        </div>

        <div id="output" class="" style="margin-left: auto; margin-right: auto;" :style="edit?'width: 840px;':'width: 750px;'">
          <div v-if="!template1">
            <div class="mb-2" style="width: 100%;">
              <!-- 編集モード -->
              <div v-if="edit">
                <!-- タイトル -->
                <div class="mt-2 flex mb-1 mx-1">
                  <div class="py-2 bg-gray-300 items-stretch w-28 text-center rounded-l">
                    タイトル
                  </div>
                  <input
                    type="text"
                    placeholder="こちらにタイトルを入力してください"
                    class="border border-gray-300 rounded-r leading-5 focus:bg-white focus:ring-white focus:placeholder-gray-500 focus:text-gray-900 w-full text-center font-bold"
                    v-model="report.title"
                    :disabled="type==5&&report.title&&report.title.indexOf('毎日')>-1"
                    @change="changeText()"
                  />
                </div>
                <!-- 得意先名 -->
                <div v-if="[1, 2, 7].includes(type)" class="flex mb-1 mx-1">
                  <div class="py-2 bg-gray-300 items-stretch w-28 text-center rounded-l">
                    得意先名
                  </div>
                  <input
                    type="text"
                    class="border border-gray-300 rounded-r leading-5 focus:bg-white focus:ring-white focus:placeholder-gray-500 focus:text-gray-900 w-full font-bold"
                    v-model="report.clientName"
                    @change="changeText()"
                  />
                </div>
                <!-- 物件名 -->
                <div v-if="[1, 2, 7].includes(type)" class="flex mb-1 mx-1">
                  <div class="py-2 bg-gray-300 items-stretch w-28 text-center rounded-l">
                    物件名
                  </div>
                  <input
                    type="text"
                    class="border border-gray-300 rounded-r leading-5 focus:bg-white focus:ring-white focus:placeholder-gray-500 focus:text-gray-900 w-full font-bold"
                    v-model="report.siteName"
                    @change="changeText()"
                  />
                </div>

                <div v-if="![1, 2, 7].includes(type)" class="flex mb-1 mx-1">
                  <!-- 支店名 -->
                  <div v-if="[3, 4].includes(type)" class="flex mb-1 mr-1 w-1/2">
                    <div class="py-2 bg-gray-300 items-stretch w-28 text-center rounded-l">
                      支店名
                    </div>
                    <select
                      name="officeName"
                      v-model="report.officeName"
                      class="border-gray-300 rounded-r leading-5 focus:bg-white focus:ring-white focus:placeholder-gray-500 focus:text-gray-900 font-bold w-full"
                      @change="changeText()"
                    >
                      <option
                        v-for="(o, i) in officeList" :key="'office' + i"
                        :value="o.name"
                        class="bg-white">
                        {{ o.name }}
                      </option>
                    </select>
                  </div>
                  <!-- 部署名 -->
                  <div class="flex mb-1" :class="![3, 4].includes(type)?'w-full':'ml-1 w-1/2'">
                    <div class="py-2 w-28 bg-gray-300 items-stretch text-center rounded-l">
                      部署名
                    </div>
                    <select
                      name="departmentName"
                      v-model="report.departmentName"
                      class="border-gray-300 rounded-r leading-5 focus:bg-white focus:ring-white focus:placeholder-gray-500 focus:text-gray-900 font-bold w-full"
                      @change="changeText()"
                    >
                      <option
                        v-for="(d, i) in departmentList" :key="'department' + i"
                        :value="d.name"
                        class="bg-white">
                        {{ d.name }}
                      </option>
                    </select>
                  </div>
                </div>

                <div v-if="![1, 2].includes(type)" class="flex mb-1 mx-1">
                  <!-- 名前 -->
                  <div style="display: flex; margin-right: 0.25rem; width: 50%;">
                    <div style="background: lightgray; padding-top: 0.5rem; padding-bottom: 0.5rem; border: 1px solid lightgray; align-items: stretch; width: 7rem; text-align: center; border-top-left-radius: 0.25rem; border-bottom-left-radius: 0.25rem;">
                      名前
                    </div>
                    <div style="width: 100%; font-weight: 700; padding: 0.5rem 1rem; border-width: 1px; border: 1px solid lightgray; border-top-right-radius: 0.25rem; border-bottom-right-radius: 0.25rem;">
                      {{ user }}
                    </div>
                  </div>
                  <!-- 日付 -->
                  <div v-if="![6, 7].includes(type)" style="display: flex; margin-left: 0.25rem; width: 50%;">
                    <div style="background: lightgray; padding-top: 0.5rem; padding-bottom: 0.5rem; border: 1px solid lightgray; align-items: stretch; width: 7rem; text-align: center; border-top-left-radius: 0.25rem; border-bottom-left-radius: 0.25rem;">
                      点検月
                    </div>
                    <div style="width: 100%; font-weight: 700; padding: 0.5rem 1rem; border-width: 1px; border: 1px solid lightgray; border-top-right-radius: 0.25rem; border-bottom-right-radius: 0.25rem;">
                      {{ updateDateMonth }}
                    </div>
                  </div>
                  <div v-else style="display: flex; margin-left: 0.25rem; width: 50%;">
                    <div style="background: lightgray; padding-top: 0.5rem; padding-bottom: 0.5rem; border: 1px solid lightgray; align-items: stretch; width: 7rem; text-align: center; border-top-left-radius: 0.25rem; border-bottom-left-radius: 0.25rem;">
                      日付
                    </div>
                    <div style="width: 100%; font-weight: 700; padding: 0.5rem 1rem; border-width: 1px; border: 1px solid lightgray; border-top-right-radius: 0.25rem; border-bottom-right-radius: 0.25rem;">
                      {{ formatDate(updateDate) }}
                    </div>
                  </div>
                </div>

                <!-- 昼食サポート -->
                <div v-if="type==6" class="text-red-700 mt-3 text-center text-sm">※同行者・新人名はチャットに表示されます</div>
                <div v-if="type==6" class="flex mb-1 mx-1">
                  <!-- 同行者 -->
                  <div style="display: flex; margin-right: 0.25rem; width: 50%;">
                    <div class="py-2 bg-gray-300 items-stretch w-28 text-center rounded-l">
                      同行者
                    </div>
                    <input
                      type="text"
                      class="border border-gray-300 rounded-r leading-5 focus:bg-white focus:ring-white focus:placeholder-gray-500 focus:text-gray-900 w-full font-bold"
                      v-model="report.staff1"
                      :class="report.staff1?'':'bg-red-200'"
                      @change="changeText()"
                    />
                  </div>
                  <!-- 新人 -->
                  <div style="display: flex; margin-left: 0.25rem; width: 50%;">
                    <div class="py-2 bg-gray-300 items-stretch w-28 text-center rounded-l">
                      新人名
                    </div>
                    <input
                      type="text"
                      class="border border-gray-300 rounded-r leading-5 focus:bg-white focus:ring-white focus:placeholder-gray-500 focus:text-gray-900 w-full font-bold"
                      v-model="report.staff2"
                      :class="report.staff2?'':'bg-red-200'"
                      @change="changeText()"
                    />
                  </div>
                </div>
              </div>

              <!-- 参照モード -->
              <div v-else @click="showAlert()">
                <!-- タイトル -->
                <div class="mt-4" style="white-space: pre-line; width: 100%; font-weight: 700; text-align: center;">
                  {{ report.title }}
                </div>
                <!-- 得意先名 -->
                <div v-if="[1, 2, 7].includes(type)" style="display: flex; margin: 0.25rem;">
                  <div style="background: lightgray; padding-top: 0.5rem; padding-bottom: 0.5rem; border: 1px solid lightgray; align-items: stretch; width: 7rem; text-align: center; border-top-left-radius: 0.25rem; border-bottom-left-radius: 0.25rem;">
                    得意先名
                  </div>
                  <div style="width: 100%; font-weight: 700; padding: 0.5rem 1rem; border-width: 1px; border: 1px solid lightgray; border-top-right-radius: 0.25rem; border-bottom-right-radius: 0.25rem;">
                    {{ report.clientName }}
                  </div>
                </div>
                <!-- 物件名 -->
                <div v-if="[1, 2, 7].includes(type)" style="display: flex; margin: 0.25rem;">
                  <div style="background: lightgray; padding-top: 0.5rem; padding-bottom: 0.5rem; border: 1px solid lightgray; align-items: stretch; width: 7rem; text-align: center; border-top-left-radius: 0.25rem; border-bottom-left-radius: 0.25rem;">
                    物件名
                  </div>
                  <div style="width: 100%; font-weight: 700; padding: 0.5rem 1rem; border-width: 1px; border: 1px solid lightgray; border-top-right-radius: 0.25rem; border-bottom-right-radius: 0.25rem;">
                    {{ report.siteName }}
                  </div>
                </div>

                <div v-if="![1, 2, 7].includes(type)" style="display: flex; margin: 0.25rem; width: 100%;">
                  <!-- 支店名 -->
                  <div v-if="![5, 6].includes(type)" style="display: flex; margin-right: 0.25rem; width: 50%;">
                    <div style="background: lightgray; padding-top: 0.5rem; padding-bottom: 0.5rem; border: 1px solid lightgray; align-items: stretch; width: 7rem; text-align: center; border-top-left-radius: 0.25rem; border-bottom-left-radius: 0.25rem;">
                      支店名
                    </div>
                    <div style="width: 100%; font-weight: 700; padding: 0.5rem 1rem; border-width: 1px; border: 1px solid lightgray; border-top-right-radius: 0.25rem; border-bottom-right-radius: 0.25rem;">
                      {{ report.officeName }}
                    </div>
                  </div>
                  <!-- 部署名 -->
                  <div style="display: flex;" :style="[5, 6].includes(type)?'width: 100%;':'margin-left: 0.25rem; width: 50%;'">
                    <div style="background: lightgray; padding-top: 0.5rem; padding-bottom: 0.5rem; border: 1px solid lightgray; align-items: stretch; width: 7rem; text-align: center; border-top-left-radius: 0.25rem; border-bottom-left-radius: 0.25rem;">
                      部署名
                    </div>
                    <div style="width: 100%; font-weight: 700; padding: 0.5rem 1rem; border-width: 1px; border: 1px solid lightgray; border-top-right-radius: 0.25rem; border-bottom-right-radius: 0.25rem;">
                      {{ report.departmentName }}
                    </div>
                  </div>
                </div>

                <div v-if="![1, 2].includes(type)" style="display: flex; margin: 0.25rem; width: 100%;">
                  <!-- 名前 -->
                  <div style="display: flex; margin-right: 0.25rem; width: 50%;">
                    <div style="background: lightgray; padding-top: 0.5rem; padding-bottom: 0.5rem; border: 1px solid lightgray; align-items: stretch; width: 7rem; text-align: center; border-top-left-radius: 0.25rem; border-bottom-left-radius: 0.25rem;">
                      名前
                    </div>
                    <div style="width: 100%; font-weight: 700; padding: 0.5rem 1rem; border-width: 1px; border: 1px solid lightgray; border-top-right-radius: 0.25rem; border-bottom-right-radius: 0.25rem;">
                      {{ user }}
                    </div>
                  </div>
                  <!-- 日付 -->
                  <div v-if="![6, 7].includes(type)" style="display: flex; margin-left: 0.25rem; width: 50%;">
                    <div style="background: lightgray; padding-top: 0.5rem; padding-bottom: 0.5rem; border: 1px solid lightgray; align-items: stretch; width: 7rem; text-align: center; border-top-left-radius: 0.25rem; border-bottom-left-radius: 0.25rem;">
                      点検月
                    </div>
                    <div style="width: 100%; font-weight: 700; padding: 0.5rem 1rem; border-width: 1px; border: 1px solid lightgray; border-top-right-radius: 0.25rem; border-bottom-right-radius: 0.25rem;">
                      {{ updateDateMonth }}
                    </div>
                  </div>
                  <div v-else style="display: flex; margin-left: 0.25rem; width: 50%;">
                    <div style="background: lightgray; padding-top: 0.5rem; padding-bottom: 0.5rem; border: 1px solid lightgray; align-items: stretch; width: 7rem; text-align: center; border-top-left-radius: 0.25rem; border-bottom-left-radius: 0.25rem;">
                      日付
                    </div>
                    <div style="width: 100%; font-weight: 700; padding: 0.5rem 1rem; border-width: 1px; border: 1px solid lightgray; border-top-right-radius: 0.25rem; border-bottom-right-radius: 0.25rem;">
                      {{ formatDate(updateDate) }}
                    </div>
                  </div>
                </div>

                <!-- 昼食サポート -->
                <div v-if="type==6" class="flex mt-3 mb-1 mx-1">
                  <div style="display: flex; margin-right: 0.25rem; width: 50%;">
                    <div style="background: lightgray; padding-top: 0.5rem; padding-bottom: 0.5rem; border: 1px solid lightgray; align-items: stretch; width: 7rem; text-align: center; border-top-left-radius: 0.25rem; border-bottom-left-radius: 0.25rem;">
                      同行者
                    </div>
                    <div style="width: 100%; font-weight: 700; padding: 0.5rem 1rem; border-width: 1px; border: 1px solid lightgray; border-top-right-radius: 0.25rem; border-bottom-right-radius: 0.25rem;">
                      {{ report.staff1 }}
                    </div>
                  </div>
                  <!-- 部署名 -->
                  <div style="display: flex; margin-left: 0.25rem; width: 50%;">
                    <div style="background: lightgray; padding-top: 0.5rem; padding-bottom: 0.5rem; border: 1px solid lightgray; align-items: stretch; width: 7rem; text-align: center; border-top-left-radius: 0.25rem; border-bottom-left-radius: 0.25rem;">
                      新人名
                    </div>
                    <div style="width: 100%; font-weight: 700; padding: 0.5rem 1rem; border-width: 1px; border: 1px solid lightgray; border-top-right-radius: 0.25rem; border-bottom-right-radius: 0.25rem;">
                      {{ report.staff2 }}
                    </div>
                  </div>
                </div>

                <div v-if="![1, 2].includes(type)" style="display: flex; margin: 0.25rem;">
                </div>
              </div>
            </div>

            <!-- 写真・コメント 編集モード -->
            <div v-if="edit" style="display: table;" class="flex flex-wrap">
              <draggable
                key="items"
                :list="report.item"
                direction="vertical"
                handle=".row-drag-handle"
                tag="div"
                @change="changeItemSort"
              >
                <div v-for="(row, i) in report.item" :key="i" style="display: inline-block; break-inside: avoid; width: 409px; margin: 0.25rem;" class="mb-10">

                  <!-- 編集モード -->
                  <div class="flex justify-between ml-11">
                    <!-- 項目並べ替え -->
                    <div v-if="!canNotChangeSortType.includes(type)&&report.item&&report.item.length!=1">
                      <div v-if="!loading" class="row-drag-handle rounded-t p-2 cursor-pointer text-indigo-700 border border-indigo-700 bg-indigo-100 flex text-sm">
                        <div class="self-center">項目並替</div>
                      </div>
                    </div>

                    <div>
                      <!-- 写真削除 -->
                      <div v-if="row.s3Url">
                        <div v-if="!loading" @click="deletePhoto(row)" class="rounded-t py-1.5 px-5 font-bold text-teal-700 border border-teal-700 bg-teal-100">
                          写真削除
                        </div>
                        <div v-else class="rounded-t py-10px px-11 font-bold border border-teal-700 bg-teal-100 cursor-not-allowed">
                          <LoadingIcon class="h-4 w-4 text-teal-700" />
                        </div>
                      </div>
                    </div>

                    <!-- 項目削除 -->
                    <div v-if="!row.commonItem">
                      <div v-if="!loading" @click="deleteItem(i)" class="rounded-t ml-1 py-1.5 px-5 font-bold text-red-700 border border-red-700 bg-red-50">
                        項目削除
                      </div>
                      <div v-else class="rounded-t py-10px px-11 font-bold border border-red-700 bg-red-50 cursor-not-allowed">
                        <LoadingIcon class="h-4 w-4 text-red-700" />
                      </div>
                    </div>
                  </div>

                  <div class="flex">
                    <!-- 写真加工ボタン -->
                    <div class="cursor-pointer" @click="retouchOpen(row, i)">
                      <div class="retouch-top"></div>
                      <div class="text-blue-700 text-sm p-2 align-middle retouch">
                        写真加工
                      </div>
                      <div class="retouch-bot"></div>
                    </div>

                    <div style="width: 100%; border-radius: 0.25rem; border-width: 1px; border: 1px solid lightgray; margin-bottom: auto;" class="border-gray-400">
                      <!-- 写真 -->
                      <div :draggable="draggablePhoto" @dragstart="dragStart(row)" @drop="drop(row)" @drop.prevent @dragover.prevent class="photo cursor-pointer" style="width: 100%; height: 220px; position: relative; border-bottom: 1px solid lightgray; break-inside: avoid;" @click="showAlert()">
                        <!-- <div v-if="!report.id" class="photo-not text-gray-400 font-bold text-center">作成開始を押してください</div> -->
                        <div v-if="draggablePhoto&&!row.s3Url" class="photo-not text-gray-400 font-bold text-center">「写真並替OFF」にすると写真添付できます</div>

                        <!-- 写真選択ボタン -->
                        <div v-if="report.id&&!row.s3Url&&edit&&!(onlyCameraBtn).includes(type)&&!draggablePhoto" class="photo-info2 text-gray-400 font-bold text-center">
                          <LoadingIcon v-if="loading" slot="before" class="h-6 w-6 m-auto" />
                          <Icon v-if="!loading" iconName="FolderDownload" iconType="outline" slot="before" class="h-6 w-6 m-auto" />
                          写真を添付
                        </div>
                        <input v-if="report.id&&edit&&!(onlyCameraBtn).includes(type)&&!draggablePhoto" :disabled="loading" class="file-type h-full left-0" type="file" accept="image/*" @change="imageToBase64(i, $event, false, false)" multiple />
                        <!-- カメラ起動ボタン -->
                        <div v-if="report.id&&!row.s3Url&&edit&&!draggablePhoto" class="text-gray-400 font-bold text-center" :class="(onlyCameraBtn).includes(type)?'photo-info-only':'photo-info'">
                          <LoadingIcon v-if="loading" slot="before" class="h-6 w-6 m-auto" />
                          <Icon v-if="!loading" iconName="Camera" slot="before" class="h-6 w-6 m-auto" />
                          カメラ起動
                        </div>
                        <input v-if="report.id&&edit&&!draggablePhoto" class="h-full right-0" :disabled="loading" type="file" capture="environment" accept="image/*" @change="imageToBase64(i, $event, false, true)" :class="(onlyCameraBtn).includes(type)?'file-type2':'file-type'" multiple />

                        <div v-if="edit&&report.item&&report.item.length!=1" class="drag-photo p-2 text-sm rounded-tr text-white" :class="draggablePhoto?'bg-indigo-500':'bg-gray-400'" @click="draggablePhoto=!draggablePhoto">写真並替ON/OFF</div>

                        <!-- 添付した写真 -->
                        <div v-if="row.s3Url" style="width: 100%; height: 100%;">
                          <img :src="row.s3Url" style="width: 100%; height: 100%; object-fit: contain;">
                        </div>
                      </div>

                      <!-- 編集モード -->
                      <div v-if="edit" @click="showAlert()">
                        <!-- タイトル -->
                        <div class="flex font-bold border-b border-gray-400" style="font-size: 0.8rem; line-height: 1.25rem;">
                          <div class="w-fit py-2.5 pl-3 mr-1">
                            {{ 'No.' + (i + 1) + ' ' }}
                          </div>
                          <div v-if="row.commonItem" class="whitespace-pre-line py-2.5 px-1 min-h-67">
                            {{ row.title }}
                          </div>
                          <textarea
                            v-else
                            class="border-0 w-full font-bold my-0.5 rounded"
                            v-model="row.title"
                            @change="changeItem(row)"
                          />
                        </div>

                        <!-- 内容 -->
                        <textarea
                          :rows="!row.note?3:textHeight(row.note)"
                          placeholder="詳細"
                          class="border-0 w-full rounded  "
                          style="font-size: 0.8rem; line-height: 0.9rem;"
                          v-model="row.note"
                          @change="changeItem(row)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </draggable>
            </div>

            <!-- 写真・コメント -->
            <div v-else style="display: table;" class="flex flex-wrap">
              <div v-for="(item, idx) in itemLength" :key="'item'+idx">

                <!-- PDF表示の際に切りのいいところで改ページになるように区切りのいい番号でひと塊にする -->
                <div v-if="idx%report.photosNumber==0">

                  <div v-for="(row, i) in report.item" :key="i" style="display: inline-block; break-inside: avoid;">
                    <div v-if="i>=idx&&i<idx+report.photosNumber" class="mb-10" style="width: 367px; margin: 0.25rem;">

                      <!-- 参照モード（空白） -->
                      <div style="height: 10px;"></div>

                      <div style="width: 100%; border-radius: 0.25rem; border-width: 1px; border: 1px solid lightgray; margin-bottom: auto;" class="border-gray-400">
                        <!-- 写真 -->
                        <div class="photo cursor-not-allowed" style="width: 100%; height: 220px; position: relative; border-bottom: 1px solid lightgray; break-inside: avoid;">
                          <!-- 添付した写真 -->
                          <div v-if="row.s3Url" style="width: 100%; height: 100%;">
                            <a :href="row.s3Url" :data-lightbox="100">
                              <img :src="row.s3Url" style="width: 100%; height: 100%; object-fit: contain;">
                            </a>
                          </div>
                        </div>

                        <!-- 参照モード -->
                        <div style="break-inside: avoid; margin-bottom: auto;" @click="showAlert()">
                          <!-- タイトル -->
                          <div style="width: 100%; font-weight: 700; padding-left: 0.75rem; padding-right: 0.75rem; margin: 6px 0px; white-space: pre-line; display: flex; font-size: 0.8rem; line-height: 1.25rem;">
                            <div style="padding-right: 10px; margin: 0 0 auto 0;">
                              {{ 'No.' + (i + 1) }}
                            </div>
                            <div style="width: 291px;">
                              {{ row.title }}
                            </div>
                          </div>
                          <!-- 内容 -->
                          <div style="display: table-cell; min-height: 54px; padding-left: 0.75rem; padding-right: 0.75rem; padding-bottom: 0.5rem; white-space: pre-line; font-size: 0.8rem;">
                            <div style="display: inline-block; min-height: inherit; width: 340px;">
                              {{ row.note }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 写真・コメント欄追加ボタン -->
            <div v-if="edit && !template1" class="w-fit mx-auto mt-2">
              <PrimaryButton text="項目追加" class="add-btn" @click="addItem(true)">
                <Icon slot="before" iconName="PlusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
              </PrimaryButton>
            </div>

            <!-- 備考 -->
            <div v-if="!([3, 4, 5, 6]).includes(type)" id="note" style="margin-top: 10px; margin-left: 4px; margin-right: 4px;">
              <div v-if="edit">
                <textarea
                  :rows="6"
                  placeholder="備考"
                  class="border border-gray-400 w-full rounded"
                  v-model="report.note"
                  @change="changeText()"
                />
              </div>
              <div v-else-if="report.note" style=" break-inside: avoid; white-space: pre-line; border: 1px solid lightgray; padding: 0.75rem; border-radius: 0.25rem;">
                {{ report.note }}
              </div>
            </div>
          </div>

          <!--************************ テンプレート1バージョン ************************-->
          <div v-else>
            <div class="mb-2" style="width: 100%;" @click="showAlert()">
              <!-- 写真ボタン -->
              <div v-if="edit" class="flex">
                <!-- 写真削除 -->
                <div v-if="report.coverPhoto">
                  <div v-if="!loading" @click="deleteCoverPhoto(report)" class="rounded-t py-1.5 px-5 font-bold text-teal-700 border border-teal-700 bg-teal-100">
                    写真削除
                  </div>
                  <div v-else class="rounded-t py-10px px-11 font-bold border border-teal-700 bg-teal-100 cursor-not-allowed">
                    <LoadingIcon class="h-4 w-4 text-teal-700" />
                  </div>
                </div>
              </div>
              <!-- 表紙 -->
              <div style="position: relative; page-break-after: always; height: 1120px; overflow: hidden; border-radius: 10px;" :style="setBgColor()">
                <div class="cursor-pointer" style="position: absolute; background: white; break-inside: avoid; left: 50%; transform: translateX(-50%); width: 99.9%; height: 68%; ">
                  <div v-if="!report.id" class="photo-not text-gray-400 font-bold text-center">作成開始を押してください</div>
                  <div v-else-if="!report.coverPhoto&&edit" class="photo-info text-gray-400 font-bold text-center" style="left: 42%;">写真を添付</div>
                  <!-- 写真添付ボタン -->
                  <input v-if="report.id&&edit" class="file-type w-full h-full" :disabled="loading" type="file" accept="image/*" @change="imageToBase64(report, $event, true, false)" />

                  <!-- 添付した写真 -->
                  <div v-if="report.coverPhoto" style="width: 100%; height: 100%;">
                    <img :src="report.coverPhoto" style="width: 100%; height: 100%; object-fit: cover;">
                  </div>
                </div>

                <div style="width: 130%; height: 40%; transform-origin: left bottom; transform: rotate(-20deg); top: 70%; position: absolute;" :style="setBgColor()">
                </div>

                <!-- 得意先名 -->
                <div style="position: absolute; font-weight: bold; top: 55%; right: 0; width: 100%;">
                  <input
                    v-if="edit"
                    type="text"
                    style="border-style: none; font-weight: bold; font-size: xx-large; background: rgb(248 248 255 / 60%); width: 100%; padding-bottom: 0px;"
                    :style="clientColor()"
                    v-model="report.clientName"
                    @change="changeText()"
                  />
                  <div v-else style="font-size: xx-large; background: rgb(248 248 255 / 60%); width: 100%;" :style="clientColor()">
                    <div style="margin-right: 15px; margin-left: 15px; padding: 5px 0;">
                      {{ report.clientName }}
                    </div>
                  </div>
                </div>

                <!-- 物件名 -->
                <div style="position: absolute; font-weight: bold; top: 59.7%; right: 0; width: 100%; ">
                  <input
                    v-if="edit"
                    type="text"
                    style="border-style: none; font-weight: bold; font-size: x-large; width: 100%; background: rgb(248 248 255 / 40%);"
                    :style="textColor() + siteAlign()"
                    v-model="report.siteName"
                    @change="changeText()"
                  />
                  <div v-else style="font-size: x-large; width: 100%; background: rgb(248 248 255 / 40%);" :style="textColor() + siteAlign()">
                    <div style="margin-right: 15px; margin-left: 15px; padding: 9px 0;">
                      {{ report.siteName }}
                    </div>
                  </div>
                </div>

                <!-- タイトル -->
                <div style="position: absolute; font-weight: bold; top: 75%; width: 100%;">
                  <input
                    v-if="edit"
                    type="text"
                    style="border-style: none; font-weight: bold; font-size: x-large; background: transparent; width: 100%;"
                    :style="titleColor()"
                    class="text-center"
                    v-model="report.title"
                    @change="changeText()"
                  />
                  <div v-else style="margin: 6px auto; width: fit-content; font-size: x-large; background: transparent;" :style="titleColor()">
                    {{ report.title }}
                  </div>
                </div>

                <!-- ロゴ -->
                <div style="position: absolute; bottom: 0; right: 0; width: 100%;"  :style="setBgColor()">
                  <img :src="logo" style="height: 30px; width: 224px; margin: 5px 10px 5px auto; display: block;" />
                  <div style="color: white; margin: 0 10px 3px auto; width: fit-content;">TEL.03-5438-8804</div>
                </div>
              </div>
            </div>

            <!-- 写真・コメント -->
            <div style="width: 100%;">
              <div v-for="(row, i) in report.item" :key="i" style="width: 100%;">
                <div v-if="row.s3Url" style="display: inline-block; width: 100%; break-inside: avoid; height: 220px; margin: 30px 0;">
                  <!-- 編集モード -->
                  <div v-if="edit" class="flex justify-between">
                    <div class="flex">
                      <!-- 写真削除 -->
                      <div v-if="row.s3Url">
                        <div v-if="!loading" @click="deletePhoto(row)" class="rounded-t py-1.5 px-5 font-bold text-teal-700 border border-teal-700 bg-teal-100">
                          写真削除
                        </div>
                        <div v-else class="rounded-t py-10px px-11 font-bold border border-teal-700 bg-teal-100 cursor-not-allowed">
                          <LoadingIcon class="h-4 w-4 text-teal-700" />
                        </div>
                      </div>
                    </div>

                    <!-- 項目削除 -->
                    <div v-if="!row.commonItem">
                      <div v-if="!loading" @click="deleteItem(i)" class="rounded-t ml-1 py-1.5 px-5 font-bold text-red-700 border border-red-700 bg-red-50">
                        項目削除
                      </div>
                      <div v-else class="rounded-t py-10px px-11 font-bold border border-red-700 bg-red-50 cursor-not-allowed">
                        <LoadingIcon class="h-4 w-4 text-red-700" />
                      </div>
                    </div>
                  </div>

                  <div style="width: 100%; height: 100%; border-radius: 0.25rem; display: flex; border: 1px solid lightgray;">
                    <!-- 写真 -->
                    <div class="photo cursor-pointer" style="width: 40%; height: 100%; position: relative; break-inside: avoid; border-right: 1px solid lightgray;">

                      <!-- 添付した写真 -->
                      <div v-if="row.s3Url" style="width: 100%; height: 100%;">
                        <img :src="row.s3Url" style="width: 100%; height: 100%; border-top-left-radius: 0.25rem; border-bottom-left-radius: 0.25rem; border-bottom-right-radius: 0.25rem; object-fit: contain;">
                      </div>
                    </div>

                    <!-- 編集モード -->
                    <!-- <div v-if="edit" style="width: 60%;" class="border-l border-gray-300"> -->
                      <!-- タイトル -->
                      <!-- <div class="font-bold border-b w-full text-sm flex">
                        <div class="w-fit py-2.5 pl-3 mr-1">
                          {{ 'No.' + (i + 1) + ' ' }}
                        </div>
                        <textarea
                          class="border-0 w-full font-bold my-0.5 rounded text-sm"
                          style="resize: none;"
                          v-model="row.title"
                          @change="changeItem(row)"
                        />
                      </div> -->

                      <!-- 内容 -->
                      <!-- <textarea
                        :rows="!row.note?3:textHeight(row.note)"
                        placeholder="詳細"
                        class="border-0 w-full rounded"
                        style="font-size: 1rem; line-height: 1.7rem; resize: none; height: 152px;"
                        v-model="row.note"
                        @change="changeItem(row)"
                      />
                    </div> -->

                    <!-- 参照モード -->
                    <div  style="break-inside: avoid; width: 60%;" @click="showAlert()">
                      <!-- タイトル -->
                      <div style="display: flex; height: 46px; border-top-right-radius: 0.25rem; width: 100%; font-weight: 700; white-space: pre-line; font-size: 0.875rem; line-height: 1.25rem; "  :style="setBgColor() +  textColor()">
                        <div style="padding-right: 10px; margin: auto 0 auto 0.75rem;">
                          {{ 'No.' + (i + 1) }}
                        </div>
                        <div style="margin: auto 0.75rem auto 0; height: fit-content; ">
                          {{ row.title }}
                        </div>
                      </div>
                      <!-- 内容 -->
                      <div style="display: table-cell; padding: 0.7rem 0.75rem; white-space: pre-line; font-size: 1rem; line-height: 1.7rem; width: 100%;">
                        <div style="display: inline-block; min-height: inherit; width: 100%;">
                          {{ row.note }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 備考 -->
            <div class="mx-1" style="margin-top: 10px;">
              <div v-if="edit">
                <textarea
                  :rows="6"
                  placeholder="備考"
                  class="border border-gray-400 w-full rounded"
                  v-model="report.note"
                  @change="changeText()"
                />
              </div>
              <div v-else-if="report.note" style=" break-inside: avoid; white-space: pre-line; border: 1px solid lightgray; padding: 0.75rem; border-radius: 0.25rem;">
                {{ report.note }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="text-gray-600 font-bold animate-pulse w-fit mt-80 m-auto" style="font-size: 30px">loading...</div>
      </div>
      <div class="text-transparent">{{reload}}</div>
    </main>
    <ChangeColorModal
      v-model="openChangeColorModal"
      :open="openChangeColorModal"
      :color="report.color"
      :align="report.align"
      @close="closeChangeColor"
    />
    <RetouchModal
      v-model="retouchModal"
      :open="retouchModal"
      :target="retouchTarget"
      @closed="closeRetouch"
      @saveRetouch="saveRetouch"
    />
  </div>
</template>
<script>

import Icon from '@components/Icon.vue'
import PageHeader from '@components/PageHeader.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import DropdownButton from '@components/DropdownButton.vue'
import LoadingIcon from '@assets/loading-circle.svg'
import ChangeColorModal from './ChangeColorModal.vue'
import RetouchModal from './RetouchModal.vue'
import * as dialogs from '@libs/dialogs'
import * as logManager from '@managers/logManager'
import * as utils from '@libs/utils'
import * as backend from '@libs/backend'
import * as moment from 'moment'
import * as chatwork from '@libs/chatwork'
import * as requestPostManager from '@managers/requestPostManager'
import draggable from "vuedraggable"
import jsPDF from "jspdf"

// 背景色および得意先名
const BGCOLOR = '#09158c'
// 文字色および物件名
const TEXTCOLOR = '#e3e4ff'
// タイトル
const TITLECOLOR = '#95abf7'

// 環境整備毎日
const OFFICE_I = ['事務所']
const BIKE_I = ['BOX内整理（空）', 'BOX内定位置', 'バイクボディの洗い拭き', '前後フェンダ洗い拭き']
const CAR_I = ['車', '車']

export default {
  components: {
    Icon,
    PageHeader,
    PrimaryButton,
    DropdownButton,
    LoadingIcon,
    ChangeColorModal,
    RetouchModal,
    draggable
  },

  props: {
    // 区分名
    typeName: {
      type: String,
      default: null
    },
    // 種別
    type: {
      type: Number,
      default: null
    },
    // タイトル
    title: {
      type: String,
      default: null
    },
    // 項目固定あり
    commonItem: {
      type: Boolean,
      default: false
    },
    // 同月のみ編集可能
    editSameMonth: {
      type: Boolean,
      default: false
    },
    // 同日のみ編集可能
    editSameDay: {
      type: Boolean,
      default: false
    },
    // 作成者と同じユーザーのみ編集可能
    editSameUser: {
      type: Boolean,
      default: false
    },
    // 自動で写真に日付を記載する
    autoDate: {
      type: Boolean,
      default: false
    },
    // 完了時にチャット送信
    sendChat: {
      type: Boolean,
      default: false
    },
    // 完了時にチャット送信で写真ではなくPDF
    sendPdf: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      // データ
      report: {
        id: null,
        title: null,
        clientName: null,
        siteName: null,
        officeName: null,
        departmentName: null,
        item: [],
        note: null,
        color: { bgColor: null, textColor: null, titleColor: null },
        align: null,
        photosNumber: 6
      },
      // 最終更新者
      user: null,
      // 最終更新日
      updateDate: null,
      // 編集可能
      edit: true,
      // 即時画面表示
      reload: 0,
      // ローディング中
      loadingFirst: false,
      loading: false,
      // 表示順の最大値
      maxSortNo: 0,
      // 支店リスト（アポロ）
      officeList: [
        { name: '東京支店' },
        { name: '東京西支店' }
      ],
      // 部署リスト（アポロ）
      departmentList: [],
      // テンプレート1に変換
      template1: false,
      // 出力メニュー
      downloadMenu: [
        { value: 1, text: 'Excel' },
        { value: 2, text: 'PDF' },
        { value: 3, text: '写真のみ1枚/1page' },
      ],
      // アポロ管財ロゴ
      logo: `${utils.getSystemOrigin()}${process.env.VUE_APP_PUBLICPATH}images/logo.png`,
      // バイク点検編集不可
      cannotEdit: false,
      // テンプレートの色変更モーダル
      openChangeColorModal: false,
      // 写真加工モーダル
      retouchModal: false,
      // 写真加工対象データ
      retouchTarget: null,
      // カメラ起動ボタンのみの種別
      onlyCameraBtn: [3, 4, 5],
      // 戻るボタン
      backBtn: false,
      // ドラッグしたアイテム
      dragItem: null,
      // 項目並べ替え不可能種別
      canNotChangeSortType: [2, 3, 4],
      draggablePhoto: false
    }
  },

  async created() {
    // データ取得
    await this.getData()
    // 部署リスト取得
    this.departmentList = utils.clone(this.$store.getters.departmentList)
    // 部署リストに「なし」を追加
    this.departmentList.unshift({ name: 'なし' })
  },

  computed: {
    /**
     * 項目の詳細内容の高さを自動で高くする（編集）
     */
    textHeight() {
      return (note) => {
        // 改行ごとに配列
        const arr = note.split('\n')
        let res = arr.length
        for (let i = 0; i < arr.length; i++) {
          const text = arr[i]
          // 30文字以上なら+1
          if (text.length > 30) {
            res++
          }
        }
        if (res < 3) {
          res = 3
        }
        return res
      }
    },

    /**
     * フリー・現地調査以外の点検月
     */
    updateDateMonth() {
      if (![1, 2].includes(this.type)) {
        if (this.updateDate) {
          let res = this.updateDate.substr(0, 7)
          return res.replace('/', '年') + '月'
        }
      }
      return null
    },

    /**
     * 日付を日本語に変換
     */
    formatDate() {
      return (val) => {
        if (val) {
          return val.replace('/', '年').replace('/', '月') + '日'
        }
        return ''
      }
    },

    /**
     * スマホ
     */
    isMobileDevice() {
      return utils.deviceInfo.isMobile
    },

    /**
     * 項目の数分の数字配列生成
     */
    itemLength() {
      if (this.maxSortNo) {
        const arr = []
        for (let i = 0; i <= this.maxSortNo; i++) {
          arr.push(i)
        }
        return arr
      }
      return []
    }
  },

  methods: {
    /**
     * データ取得
     */
    async getData() {
      // console.log(reportID)
      this.loadingFirst = true
      window.scroll({ top: 0 })
      this.report = {}
      this.report.title = this.title
      for (let i = 0; i < 6; i++) {
        this.addItem()
      }

      let reportID

      // 一覧から開いた場合
      if (this.$route.query.id) {
        reportID = this.$route.query.id
        if (this.$route.query.routeName) {
          this.backBtn = true
        } else {
          this.backBtn = false
        }
      }

      // 編集の場合
      if (reportID) {
        const res = await backend.searchData('photoReport/get', { id: reportID })
        if (res.data.data) {
          this.report = res.data.data
          this.user = res.data.data.updateUserName
          this.updateDate = res.data.data.updateDate

          // 項目の最大表示順を取得
          if (this.report.item && this.report.item.length) {
            this.maxSortNo = Number(this.report.item.slice(-1)[0].sortNo)

          // 同行の場合
          } else if (this.type == 7) {
            const res = await backend.searchData('photoReport/getCommonItem', { type: this.type })
            if (res.data.data && res.data.data.length) {
              this.report.item = []
              for (let i = 0; i < res.data.data.length; i++) {
                const r = res.data.data[i]
                this.report.item.push({ title: r.title, commonItem: true, sortNo: r.sortNo, photoKey: r.sortNo })
              }
              this.maxSortNo = Number(this.report.item.slice(-1)[0].sortNo)
            } else {
              this.maxSortNo = 0
              for (let i = 0; i < 12; i++) {
                this.addItem()
              }
            }
            const common = this.commonSaveData()
            await backend.postData('photoReport/insertItems', { item: this.report.item, ...common })
          }
        }
        this.edit = false

        // 同月のみ編集可、同日のみ編集可、もしくは作成者のみ編集可の場合
        if (this.editSameMonth || this.editSameUser || this.editSameDay) {
          let user = true
          let month = true
          let day = true

          // ユーザーが違う場合、編集不可
          if (this.editSameUser && this.user != utils.deleteKana(this.$store.getters.user.user_name)) {
            user = false
          }
          // 年月が違えば編集不可
          if (this.editSameMonth) {
            let today = moment().format('YYYY年MM月')
            if (today != this.updateDateMonth) {
              month = false
            }
          }
          // 作成日が違えば編集不可
          if (this.editSameDay) {
            let today = moment().format('YYYY-MM-DD')
            if (today != this.report.insertDate) {
              day = false
            }
          }
          if (user && month && day) {
            this.cannotEdit = false
          } else {
            this.cannotEdit = true
          }
        }

      // 新規で項目固定の場合
      } else if (this.commonItem) {
        if (this.type != 5) {
          const res = await backend.searchData('photoReport/getCommonItem', { type: this.type })
          if (res.data.data && res.data.data.length) {
            this.report.item = []
            for (let i = 0; i < res.data.data.length; i++) {
              const r = res.data.data[i]
              this.report.item.push({ title: r.title, commonItem: true, sortNo: r.sortNo, photoKey: r.sortNo })
            }
          }
        } else {
          this.report.item = []
          let item = utils.clone(OFFICE_I)
          if (this.typeName.indexOf('バイク') > -1) {
            item = utils.clone(BIKE_I)
          } else if (this.typeName.indexOf('車') > -1) {
            item = utils.clone(CAR_I)
          }
          for (let i = 0; i < item.length; i++) {
            const it = item[i]
            this.report.item.push({ title: it, commonItem: true, sortNo: (i + 1), photoKey: (i + 1) })
          }
        }
        this.maxSortNo = Number(this.report.item.slice(-1)[0].sortNo)
      }

      // フリーもしくは現地調査の場合、色の設定
      if (this.type == 1 || this.type == 2) {
        if (!this.report.color) {
          this.report.color = { bgColor: BGCOLOR, textColor: TEXTCOLOR, titleColor: TITLECOLOR }
        } else {
          if (!this.report.color.bgColor) {
            this.report.color.bgColor = BGCOLOR
          }
          if (!this.report.color.textColor) {
            this.report.color.textColor = TEXTCOLOR
          }
          if (!this.report.color.titleColor) {
            this.report.color.titleColor = TITLECOLOR
          }
        }
      // フリー、現地調査以外
      } else {
        this.report.color = { bgColor: null, textColor: null, titleColor: null }
      }

      // バイク・車両点検などで新規作成の場合
      if (!reportID && ![1, 2].includes(this.type) && !this.report.departmentName) {
        // 所属部署を初期値で入れる
        const userInfo = this.$store.getters.loginUserData
        this.report.departmentName = userInfo.departmentName
        if (!this.report.departmentName) {
          this.report.departmentName = 'なし'
        }
      }
      this.reload++
      this.loadingFirst = false

      // ページの写真枚数 初期化
      if (!this.report.photosNumber) this.report.photosNumber = 6

      // 新規の場合は、作成開始ボタンを押下
      if (!reportID) {
        this.start()
      }
    },

    /**
     * 写真添付Base64に変換
     * @param row 対象項目
     * @param event
     * @param cover 表紙の写真
     * @param isCameraBtn カメラボタン押下
     */
    async imageToBase64 (idx, event, cover, isCameraBtn) {
      this.loading = true
      const isOk = await this.showAlert()
      if (!isOk) {
        this.loading = false
        return
      }

      // 選択されたファイルの取得
      const file = event.target.files
      // Base64に変換する
      for (let j = 0; j < file.length; j++) {
        const reader = new FileReader()
        const f = file[j]

        reader.readAsDataURL(f)
        // 変換
        const compressedImage = await new Promise((resolve) => {
          reader.onload = () => {
            const img = new Image();
            img.src = reader.result;

            img.onload = () => {
              const compressedDataUrl = this.compressImage(img, null, isCameraBtn, cover)
              resolve(compressedDataUrl)
            }
          }
        })

        // 表紙の場合、1枚に限る
        if (cover) {
          // 保存
          await this.savePhoto(idx, cover, compressedImage)
        } else {
          // 項目の枠がない場合
          if (!this.report.item[idx + j]) {
            this.addItem()
          }
          // 複数ある場合は、次の項目にはめる
          await this.savePhoto(this.report.item[idx + j], cover, compressedImage)
        }

        this.reload++
      }
    },

    /**
     * 画像圧縮
     * @param {dataURL} img
     */
    compressImage(img, dt, isCameraBtn, cover) {
      // 画像のサイズを変更するためにリサイズ処理
      let maxWidth = 900 // リサイズ後の最大幅
      // 圧縮率（質）
      let quality = 0.8 // 見た目そのまま、でも軽い（0.8）

      // フリー、現地調査以外ならもっと小さくする
      if (![1, 2].includes(this.type)) {
        maxWidth = 500
        quality = 0.6
      }

      let width = img.width
      let height = img.height

      // 横長の場合
      if (width >= height) {
        if (width > maxWidth) {
          height *= maxWidth / width
          width = maxWidth
        }
      // 縦長で表紙ではない場合
      } else if (!cover) {
        if (height > maxWidth) {
          width *= maxWidth / height
          height = maxWidth
        }
      }
      // 新しいキャンバスを作成
      const canvas = document.createElement('canvas')
      canvas.width = width
      canvas.height = height

      // キャンバスに描画するためのコンテキストを取得
      const ctx = canvas.getContext('2d')
      // 画像をキャンバスに描画せずに直接リサイズ
      ctx.drawImage(img, 0, 0, width, height)
      // 自動で日付表示する場合
      if (this.autoDate && isCameraBtn) {
        // 写真撮影日時を写真に描画
        utils.setDateToImg(dt, canvas, ctx, false)
      }
      // キャンバスの画像を再度DataURLに変換
      const compressedDataUrl = canvas.toDataURL(utils.getMimeType(img.src), quality)

      return compressedDataUrl
    },

    /**
     * 項目並べ替え
     * @param e イベント
     */
    async changeItemSort(e) {
      if (e.moved) {
        // ソート番号を更新
        const isAlert = await this.showAlert()
        if (!isAlert) {
          return
        }
        this.loading = true
        let saveData = []
        // ソートNoを変更
        for (let i = 0; i < this.report.item.length; i++) {
          const it = this.report.item[i]
          it.sortNo = (i + 1)
        }

        // 保存用にデータを加工
        const items = utils.clone(this.report.item)
        for (let i = 0; i < items.length; i++) {
          const it = items[i]
          delete it.s3Url
          saveData.push(it)
        }
        const common = this.commonSaveData()

        try {
          await backend.postData('photoReport/updateItemSort', { list: saveData, ...common })
          this.user = common.insertUserName
          this.updateDate = moment().format('YYYY/MM/DD')
          this.loading = false
        } catch (error) {
          alert('エラーが発生し、保存できませんでした\r\n' + error)
        }
      }
    },

    /**
     * 写真をドラッグ開始
     */
    async dragStart(row) {
      this.dragItem = row
    },

    /**
     * 写真をドロップ
     */
    async drop(row) {
      const isAlert = await this.showAlert()
      if (!isAlert) {
        return
      }
      if (!this.dragItem || !this.dragItem.sortNo) {
        return
      }

      if (this.dragItem.sortNo == row.sortNo) {
        return
      }
      this.loading = true
      // 対象
      const beforeDrop = utils.clone(this.dragItem)
      // 移動先
      const beforeRow = utils.clone(row)

      // 移動先に対象データを入れる
      row.s3Url = beforeDrop.s3Url
      row.photoPath = beforeDrop.photoPath
      row.photoKey = beforeDrop.photoKey
      row.isPhoto = true
      if (!beforeDrop.s3Url) {
        row.isPhoto = false
      }

      // 移動もとに移動先のデータを入れる
      this.dragItem.s3Url = beforeRow.s3Url
      this.dragItem.photoPath = beforeRow.photoPath
      this.dragItem.photoKey = beforeRow.photoKey
      this.dragItem.isPhoto = true
      if (!beforeRow.s3Url) {
        this.dragItem.isPhoto = false
      }

      const item1 = {
        beforeSortNo: this.dragItem.sortNo,
        sortNo: row.sortNo,
        photoPath: row.photoPath,
        photoKey: row.photoKey,
        isPhoto: row.isPhoto
      }

      const item2 = {
        beforeSortNo: row.sortNo,
        sortNo: this.dragItem.sortNo,
        photoPath: this.dragItem.photoPath,
        photoKey: this.dragItem.photoKey,
        isPhoto: this.dragItem.isPhoto
      }

      const common = this.commonSaveData()
      const param = {
        item: [item1, item2],
        ...common
      }
      await backend.postData('photoReport/dropPhoto', param)
      this.loading = false

      this.reload++
    },

    /**
     * 写真保存
     * @param row 対象項目
     * @param cover 表紙
     * @param photo 保存対象BASE64
     */
    async savePhoto(row, cover, photo) {
      const isAlert = await this.showAlert()
      if (!isAlert) {
        return
      }
      const common = this.commonSaveData()
      try {
        this.loading = true
        if (cover) {
          const res = await backend.postData('photoReport/updateCoverPhoto', { ...row, ...common, photo })
          // 保存した写真を表示
          row.coverPhoto = res.data.data.s3Url
        } else {
          if (!row.photoKey) {
            row.photoKey = row.sortNo
          }
          this.checkPhotoKey(row)
          const res = await backend.postData('photoReport/upsertPhoto', { ...row, ...common, photo })
          if (!res.data.data.s3Url) {
            alert('エラー発生\r\nキャッシュが残っていないかご確認ください。')
            // 一覧へ遷移
            this.toList()
            return
          }
          // 保存した写真を表示
          row.s3Url = res.data.data.s3Url
          // パス
          row.photoPath = res.data.data.path
        }
        this.user = common.insertUserName
        this.updateDate = moment().format('YYYY/MM/DD')
        row.photoReportId = this.report.id

      } catch (error) {
        alert('エラー発生\r\nキャッシュが残っていないかご確認ください。\r\n' + error)
        this.loading = false
        // 一覧へ遷移
        this.toList()
      }
      this.loading = false
      this.reload++
    },

    /**
     * 写真削除保存
     * @param row 対象項目
     */
    async saveDeletePhoto(row) {
      const isAlert = await this.showAlert()
      if (!isAlert) {
        return
      }
      const common = this.commonSaveData()
      try {
        this.loading = true
        await backend.postData('photoReport/deletePhoto', { ...row, ...common })
        
        delete row.s3Url
        delete row.photoPath
        delete row.photo

        this.user = common.insertUserName
        this.updateDate = moment().format('YYYY/MM/DD')
        row.photoReportId = this.report.id

      } catch (error) {
        alert('エラーが発生しました\r\n' + error)
        this.loading = false
      }
      this.loading = false
      this.reload++
    },

    /**
     * 表紙写真削除
     * @param row 対象項目
     */
    async deleteCoverPhoto(row) {
      const isAlert = await this.showAlert()
      if (!isAlert) {
        return
      }
      delete row.coverPhoto
      await this.savePhoto(row, true)
      this.reload++
    },

    /**
     * 写真削除
     * @param row 対象項目
     */
    async deletePhoto(row) {
      const isAlert = await this.showAlert()
      if (!isAlert) {
        return
      }
      await this.saveDeletePhoto(row)
      this.reload++
    },

    /**
     * 項目削除
     * @param i インデックス
     */
    async deleteItem(i) {
      const isAlert = await this.showAlert()
      if (!isAlert) {
        return
      }
      let title = ''
      if (this.report.item[i].title) {
        title = '「' + this.report.item[i].title + '」'
      }

      const res = await dialogs.showConfirmDialog('この項目を削除しますか？', `No.${(i + 1)} ${title}を削除してよろしいですか？`)
      if (res != 'YES') {
        return
      }

      if (this.report.item[i].photoReportId) {
        try {
          await backend.deleteData('photoReport/deleteItem', { id: this.report.item[i].photoReportId, sortNo: this.report.item[i].sortNo })
          this.user = utils.deleteKana(this.$store.getters.user.user_name)
          this.updateDate = moment().format('YYYY/MM/DD')
        } catch (error) {
          alert('エラーが発生しました\r\n' + error)
        }
      }

      this.report.item.splice(i, 1)
      this.reload++
    },

    /**
     * 項目追加
     */
    async addItem(isScroll) {
      const row = { s3Url: null, title: '', note: null, sortNo: null, photoKey: null }

      // 項目がない場合
      if (!this.report.item) {
        this.report.item = []
        row.sortNo = 1
        row.photoKey = 1
        this.maxSortNo = 1

      // 項目がある場合
      } else {
        this.maxSortNo++
        row.sortNo = this.maxSortNo
        row.photoKey = row.sortNo

        // photoKeyの確認
        this.checkPhotoKey(row)
      }
      this.report.item.push(row)

      if (isScroll) {
        await this.$nextTick()
        const note = document.getElementById('note')
        if (note) {
          note.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })
        }
      }

      this.reload++
    },

    /**
     * 写真キー（パスを生成するのに使用）
     * @param row 対象データ
     */
    checkPhotoKey(row) {
      for (let i = 0; i < this.report.item.length; i++) {
        const e = this.report.item[i]
        // photoKeyがかぶっている場合
        if (row.sortNo != e.sortNo && row.photoKey == e.photoKey) {
          row.photoKey = utils.getUniqueStr()
          this.checkPhotoKey(row)
        }
      }
    },

    /**
     * 保存時の共通項目
     */
    commonSaveData() {
      let id = null
      if (this.report.id) {
        id = this.report.id
      }
      return {
        id,
        insertUserName: utils.deleteKana(this.$store.getters.user.user_name),
        insertUser: this.$store.getters.user.id,
        type: this.type
      }
    },

    /**
     * 作成開始ボタン
     */
    async start() {
      const saveData = utils.clone(this.report)
      let common = this.commonSaveData()
      try {
        const res = await backend.postData('photoReport/newSave', { ...saveData, ...common })
        this.report.id = res.data.data
        this.user = common.insertUserName
        this.updateDate = moment().format('YYYY/MM/DD')

        // 昼食サポートの場合
        if (this.type == 6) {
          this.report.staff1 = this.user
        }

        for (let i = 0; i < this.report.item.length; i++) {
          const it = this.report.item[i]
          it.photoReportId = this.report.id
        }
      } catch (error) {
        alert('エラーが発生しました\r\n' + error)
      }
    },

    /**
     * 編集不可アラート表示
     */
    async showAlert() {
      if (this.cannotEdit) {
        return false
      }
      if (!this.report.id) {
        await dialogs.showErrorDialog('作成開始ボタンを押してください', '作成開始ボタンを押すとデータの保存が開始されます。')
        return false
      } else if (!this.edit) {
        await dialogs.showErrorDialog('編集ボタンを押してください。', '編集ボタンを押すとデータを更新できるようになります。')
        return false
      }
      return true
    },

    /**
     * テキスト変更イベント
     */
    async changeText() {
      const isAlert = await this.showAlert()
      if (!isAlert) {
        return
      }
      const saveData = utils.clone(this.report)
      delete saveData.item
      const common = this.commonSaveData()

      try {
        await backend.postData('photoReport/updateText', { ...saveData, ...common })
        this.user = common.insertUserName
        this.updateDate = moment().format('YYYY/MM/DD')
      } catch (error) {
        alert('エラーが発生しました\r\n' + error)
      }
    },

    /**
     * 項目変更イベント
     * @param row 対象行
     */
    async changeItem(row) {
      const isAlert = await this.showAlert()
      if (!isAlert) {
        return
      }
      this.loading = true
      const saveData = utils.clone(row)
      delete saveData.photo
      const common = this.commonSaveData()

      try {
        await backend.postData('photoReport/upsertItem', { ...saveData, ...common })
        this.user = common.insertUserName
        this.updateDate = moment().format('YYYY/MM/DD')
        row.photoReportId = this.report.id
      } catch (error) {
        alert('エラーが発生しました\r\n' + error)
      }
      this.loading = false
    },

    /**
     * 編集ボタン
     */
    editBtn() {
      this.edit = true
      this.changeText()
    },

    /**
     * 完了ボタン
     */
    async completeBtn() {
      // 入力確認
      const vali = await this.validate()
      if (!vali) {
        return
      }
      this.loading = true
      const common = this.commonSaveData()

      try {
        await backend.postData('photoReport/complete', { ...common })
        this.user = common.insertUserName
        this.updateDate = moment().format('YYYY/MM/DD')

        let msg = 'タイトル「' + this.report.title + '」更新者：' + this.user + ' を完了しました。'
        logManager.recording(this, logManager.Loglevel.INFO, '報告書_' + this.typeName, '更新', msg)

        // チャット送信
        await this.sendChatMsg()
        // メインタスク完了
        await this.mainTaskDone()
      } catch (error) {
        this.loading = false
        alert('エラーが発生しました\r\n' + error)
      }
      this.loading = false
      this.edit = false
    },

    /**
     * 画像もしくはPDF付きチャット送信
     */
    async sendChatMsg() {
      if (!this.sendChat) {
        return
      }

      let chat = {}
      const chatData = await backend.searchData('photoReport/getChatwork', { type: this.type, departmentName: this.report.departmentName })
      if (chatData.data.data && chatData.data.data.length) {
        chat = chatData.data.data[0]
      }

      if (!chat || !chat.roomId || !chat.apiToken) {
        this.loading = false
        alert(`チャットワーク情報が取得できませんでした。キャッシュが残っている可能性があります。\r\nメニュー画面で警告は出ていませんか？その場合は、画面を完全に閉じ、URLから開きなおしてください。\r\nキャッシュが残っていると不具合の原因となります。`)
        return
      }

      // PDF送信
      if (this.sendPdf) {
        this.edit = false
        await utils.wait(500)

        const isTemplate = this.template1
        const param = {
          html: document.querySelector("#output").outerHTML,
          photosNumber: this.report.photosNumber,
          isTemplate,
          roomId: chat.roomId,
          token: chat.apiToken,
          fileName: this.typeName + this.user + '_' + moment().format('M月') + '.pdf',
          message: '環境整備 ' + this.typeName + ' ' + this.user + ' ' + moment().format('M月D日')
        }
        await backend.postData('photoReportDownload/chatworkPdf', param)

      } else {
        const date = moment().format('YYYY/MM/DD')
        // 昼食サポートの場合は同行者・新人
        let staff = ''
        if (this.type == 6) {
          staff = '同行者：' + this.report.staff1 + '\r\n新人　：' + this.report.staff2 + '\r\n\r\n'
        }

        // 写真がある項目（S3のキー付き）
        const items = this.report.item
          .map((r, i) => ({ no: i + 1, photoPath: r.photoPath, title: r.title || '', note: r.note || '' }))
          .filter((r) => r.photoPath)

        // 4枚以上ある場合は、バックエンドで4枚ずつ1枚の画像に合成して送信
        if (items.length >= 4) {
          await backend.postData('photoReportDownload/chatworkImages', {
            id: this.report.id,
            roomId: chat.roomId,
            token: chat.apiToken,
            // 見出し（1行目：日付（更新者）、空行、昼食サポートなら同行者・新人）
            header: date + '　（' + this.user + '）\r\n\r\n' + staff,
            items
          })
          return
        }

        // 3枚以下は1枚ずつ送信
        for (let i = 0; i < this.report.item.length; i++) {
          const r = this.report.item[i]
          let msg = date + '\r\n' + staff

          if (r.s3Url) {
            const response = await fetch(r.s3Url, { cache: 'no-cache' })
            const blob = await response.blob()

            msg += `No.${(i + 1) + ' ' + (r.title || '')}（${this.user}）`
            if (r.note) {
              msg += '\r\n' + r.note
            }
            await chatwork.uploadFile(chat.roomId, chat.apiToken, msg, blob, `No.${this.report.id}_${i + 1}.png`)
            await utils.wait(100)
          }
        }
      }
    },

    /**
     * 同行メインタスク完了
     */
    async mainTaskDone() {
      if (this.type != 7) {
        return
      }
      const res = await requestPostManager.doneAccompanyTask(this, { id: this.report.id })
      if (res) {
        await dialogs.showSuccessDialog('メインタスク完了', '同行メインタスクも完了にしました。')
      }
    },

    /**
     * 報告書削除ボタン
     */
    async deleteReport() {
      const res = await dialogs.showWarningConfirmDialog('報告書を削除しますか？', 'この報告書を本当に削除してよろしいですか？')
      if (res != 'YES') {
        return
      }
      try {
        await backend.deleteData('photoReport/deleteReport', { id: this.report.id })
      } catch (error) {
        alert('エラーが発生しました\r\n' + error)
      }
      let msg = 'タイトル「' + this.report.title + '」更新者：' + this.user + ' を削除しました。'
      logManager.recording(this, logManager.Loglevel.INFO, '報告書_' + this.typeName, '削除', msg)

      // 一覧へ遷移
      this.toList()
    },

    /**
     * 入力確認
     */
    async validate() {
      const rep = this.report
      // タイトルのチェック
      if (!rep.title) {
          await dialogs.showErrorDialog('タイトルが未入力です', 'タイトルを入力してください。')
          return false
      }
      // フリー入力、現地調査
      if (this.type == 1 || this.type == 2) {
        if (!rep.clientName) {
          await dialogs.showErrorDialog('得意先名が未入力です', '得意先名を入力してください。')
          return false
        } else if (!rep.siteName) {
          await dialogs.showErrorDialog('物件名が未入力です', '物件名を入力してください。')
          return false
        }
      // バイク点検月一、車月一
      } else if ([3, 4].includes(this.type)) {
        if (!rep.officeName) {
          await dialogs.showErrorDialog('支店名が未選択です', '支店名を選択してください。')
          return false
        } else if (!rep.departmentName) {
          await dialogs.showErrorDialog('部署名が未選択です', '部署名を選択してください。')
          return false
        }
      // 毎日、昼食代
      } else if ([5, 6].includes(this.type)) {
        if (!rep.departmentName) {
          await dialogs.showErrorDialog('部署名が未選択です', '部署名を選択してください。')
          return false
        }

        // 昼食
        if (this.type == 6) {
          if (!this.report.staff1) {
            await dialogs.showErrorDialog('同行者が未入力です', '同行者を入力してください。')
            return false
          }
          if (!this.report.staff2) {
            await dialogs.showErrorDialog('新人（同行対象者）名が未入力です', '新人の名前を入力してください。')
            return false
          }
        }
      // 同行
      } else if ([7].includes(this.type)) {
        let isPhoto = false
        // 写真が1枚も添付されていなければ完了不可
        for (let i = 0; i < rep.item.length; i++) {
          const ri = rep.item[i]
          if (ri.s3Url) {
            isPhoto = true
            break
          }
        }
        if (!isPhoto) {
          alert('写真が添付されていないため、完了できません。')
          return false
        }
      }
      // チャット送信する場合
      if (this.sendChat) {
        let isPhoto = false
        let num = 0
        // 写真が1枚も添付されていなければ完了不可
        for (let i = 0; i < rep.item.length; i++) {
          const ri = rep.item[i]
          if (ri.s3Url) {
            isPhoto = true
            num++
          }
        }
        if (!isPhoto) {
          alert('写真が添付されていません。写真を少なくとも1枚は添付してください。')
          return false
        }
        if (this.type == 5 && this.report.title.indexOf('バイク') > -1) {
          if (num <= 1) {
            alert('写真が少ないです。バイク（毎日）は2箇所の写真を添付してください。')
            return false
          }
        }
      }

      const nonPhoto = []
      // 環境整備（毎日）以外
      if (this.type != 5) {
        // 写真変更したもの、共通項目で写真添付していないもの
        if (rep.item && rep.item.length) {
          for (let i = 0; i < rep.item.length; i++) {
            const item = rep.item[i]
            // 共通項目で写真添付無しのもの
            if (item.commonItem && !item.s3Url) {
              nonPhoto.push(i + 1)
            }
          }

          if (!this.template1 && nonPhoto && nonPhoto.length) {
            const res = await dialogs.showConfirmDialog(`写真がない項目があります`, `No.${nonPhoto.join('、')} の写真が添付されていません。\r\nよろしいでしょうか？`)
            if (res != 'YES') {
              return false
            }
          }
        }
      }
      return true
    },

    /**
     * テンプレート変換
     */
    changeTemplate1() {
      this.template1 = !this.template1
      if (this.template1) {
        dialogs.showInfoDialog('写真のある項目のみ表示', '写真がある項目のみ表示します。\r\n表紙の写真は、建物全体や館銘板などを添付してください。')
      }
    },

    /**
     * 出力ボタン
     */
    async downloadSelect(select) {
      this.loading = true
      let editFlag = false
      if (this.edit) {
        editFlag = true
        this.edit = false
        await utils.wait(100)
      }

      if (select.value == 1) {
        await this.excelBtn()
      } else if (select.value == 2) {
        await this.pdfBtn()
      } else if (select.value == 3) {
        await this.photoPdf()
      }

      if (editFlag) {
        this.edit = true
      }
      this.loading = false
    },

    /**
     * Excel出力
     */
    async excelBtn() {
      const res = await backend.postBlob2('photoReportDownload/excel', { checkedId: [this.report.id] })
      try {
        const uint8Array = res.data
        const blob = new Blob([uint8Array], { "Content-Type" : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const a = document.createElement("a");
        a.href = (window.URL || window.webkitURL).createObjectURL(blob)
        let name = this.report.title
        if ([1, 2].includes(this.type)) {
          name += '_' + (this.report.siteName || '物件名未入力')
        } else {
          name += '_' + this.updateDateMonth + '_' + this.user.replace('　', '')
        }

        a.download = name + '.xlsx'
        a.click();
        a.remove();
      } catch (e) {
        console.log(e)
        alert(e)
        this.loading = false
      }
    },

    /**
     * PDF出力
     */
    async pdfBtn() {
      if (this.edit) {
        alert('完了ボタンを押してください。')
        return
      }
      // 写真をさらに圧縮
      // await this.compressImageForPDF(0.7)
      await utils.wait(100)

      const isTemplate = this.template1
      const param = {
        html: document.querySelector("#output").outerHTML,
        photosNumber: this.report.photosNumber,
        isTemplate,
        note: this.report.note,
        len: this.report.item.length || 0
      }
      const res = await backend.postBlob2('photoReportDownload/pdf', param)
      try {
        const uint8Array = res.data
        const blob = new Blob([uint8Array], { type : "application/pdf" })
        const url = URL.createObjectURL(blob)
        let a = document.createElement('a')
        a.href = url
        let name = this.report.title
        if ([1, 2].includes(this.type)) {
          name += '_' + (this.report.siteName || '物件名未入力')
        } else {
          name += '_' + this.updateDateMonth + '_' + this.user.replace('　', '')
        }

        a.download = name + '.pdf'
        a.click()
        a.remove()
      } catch (e) {
        console.log(e)
        alert(e)
        this.loading = false
      }
    },

    /**
     * 写真のみのPDF
     */
    async photoPdf() {
      // PDFドキュメント 横向き
      const doc = new jsPDF('l')

      const pageW = doc.internal.pageSize.width
      const pageH = doc.internal.pageSize.height

      const list = this.report.item.filter((it) => {
        return it.s3Url
      })

      for (let i = 0; i < list.length; i++) {
        const it = list[i]
        if (it.s3Url) {
          // S3期限付きURL
          const s3Url = it.s3Url

          const { width, height } = await this.getImageNaturalSize(s3Url)

          // A4枠内に収めるスケール計算
          const margin = 10
          const maxW = pageW - margin * 2
          const maxH = pageH - margin * 2

          const ratio = Math.min(maxW / width, maxH / height)

          const drawW = width * ratio
          const drawH = height * ratio

          const left = (pageW - drawW) / 2
          const top = (pageH - drawH) / 2

          doc.addImage(s3Url, "JPEG", left, top, drawW, drawH)

          if (i !== list.length - 1) {
            doc.addPage()
          }
        }
      }
      const fileName = (this.report.siteName || `写真報告書No.${this.report.id}`)
      doc.save(fileName + '.pdf')
    },

    /**
     * 画像サイズ取得
     */
    async getImageNaturalSize(url) {
      return new Promise((resolve, reject) => {
        const img = new Image()

        img.onload = () => {
          resolve({
            width: img.naturalWidth,
            height: img.naturalHeight
          })
        }

        img.onerror = reject

        img.src = url
      })
    },

    /**
     * 画像圧縮PDF用
     */
    // async compressImageForPDF(rate) {
    //   // 画像のサイズを変更するためにリサイズ処理
    //   const maxWidth = 300 // リサイズ後の最大幅
    //   let items = this.report.item
    //   for (let i = 0; i < items.length; i++) {
    //     const it = items[i]
    //     if (it.photo) {

    //       const img = await new Promise((resolve, reject) => {
    //         const im = new Image()
    //         im.src = it.photo
    //         im.onload = () => resolve(im)
    //         im.onerror = (e) => reject(e)
    //       })

    //       let width = img.width
    //       let height = img.height
    //       // 横長の場合
    //       if (width >= height) {
    //         if (width > maxWidth) {
    //           height *= maxWidth / width
    //           width = maxWidth
    //         }
    //       // 縦長の場合
    //       } else {
    //         if (height > maxWidth) {
    //           width *= maxWidth / height
    //           height = maxWidth
    //         }
    //       }
    //       // 新しいキャンバスを作成
    //       const canvas = document.createElement('canvas')
    //       canvas.width = width
    //       canvas.height = height

    //       // キャンバスに描画するためのコンテキストを取得
    //       const ctx = canvas.getContext('2d')
    //       // 画像をキャンバスに描画せずに直接リサイズ
    //       ctx.drawImage(img, 0, 0, width, height)
    //       // キャンバスの画像を再度DataURLに変換して解像度おとす
    //       const compressedDataUrl = canvas.toDataURL(utils.getMimeType(it.photo), rate) // 圧縮率を設定
    //       it.photo = compressedDataUrl
    //     }
    //   }
    // },

    /**
     * 色変更モーダルopen
     */
    async changeColor() {
      this.openChangeColorModal = true
    },

    /**
     * 色・位置変更決定後モーダルclose
     */
    closeChangeColor(val) {
      this.report.color = val.color
      this.report.align = val.align
      this.openChangeColorModal = false

      try {
        backend.postData('photoReport/updateColor', { id: this.report.id, ...val })
      } catch (error) {
        alert('エラーが発生しました\r\n' + error)
      }
    },

    /**
     * 背景色
     */
    setBgColor() {
      if (this.report && this.report.color && this.report.color.bgColor) {
        return `background: ${this.report.color.bgColor};`
      } else {
        return `background: ${BGCOLOR};`
      }
    },

    /**
     * 得意先色（背景と同じ色）
     */
    clientColor() {
      let color = `color: ${BGCOLOR};`
      let align = 'text-align: right;'

      if (this.report && this.report.color && this.report.color.bgColor) {
        color = `color: ${this.report.color.bgColor};`
      }
      if (this.report && this.report.align) {
        align = `text-align: ${this.report.align};`
      }
      return color + ' ' + align
    },

    /**
     * 物件名色、清掃箇所色
     */
    textColor() {
      if (this.report && this.report.color && this.report.color.textColor) {
        return `color: ${this.report.color.textColor};`
      } else {
        return `color: ${TEXTCOLOR};`
      }
    },

    /**
     * 物件名の位置
     */
    siteAlign() {
      let align = 'text-align: right;'
      if (this.report && this.report.align) {
        align = `text-align: ${this.report.align};`
      }
      return ' ' + align
    },

    /**
     * タイトル色
     */
    titleColor() {
      if (this.report && this.report.color && this.report.color.titleColor) {
        return `color: ${this.report.color.titleColor};`
      } else {
        return `color: ${TITLECOLOR};`
      }
    },

    /**
     * ページの写真枚数 クリック
     */
    clickPhotosNumber(value) {
      if (!this.report.id) return
      this.report.photosNumber = value
      this.reload++

      // 項目を増やす
      let num = 0
      if (this.report.item && this.report.item.length) {
        num = this.report.item.length
      }
      if (this.report.photosNumber > num) {
        for (let i = num; i < this.report.photosNumber; i++) {
          this.addItem()
        }
      }

      const saveData = utils.clone(this.report)
      delete saveData.item
      backend.postData('photoReport/updatePhotosNumber', saveData)
    },

    /**
     * 写真加工モーダルopen
     */
    retouchOpen(row, i) {
      if (!row.s3Url) {
        alert('写真が添付されていません。')
        return
      }
      row.index = i
      this.retouchTarget = row
      this.retouchModal = true
    },

    /**
     * 写真加工モーダルclose
     */
    closeRetouch() {
      this.retouchModal = false
    },

    /**
     * 写真加工完了
     */
    saveRetouch(photo) {
      this.savePhoto(this.report.item[photo.target.index], false, photo.data)
      this.reload++
    },

    /**
     * 一覧へ遷移
     */
    toList() {
      if (this.backBtn) {
        this.previous()
      } else {
        let name = 'PhotoReportList'
        if (![1, 2, 6].includes(this.type)) {
          name = 'EnvReportList'
        }
        if (this.type == 7) {
          name = 'Accompany'
        }
        this.$router.push({
          name
        })
      }
    },

    /**
     * 前の「予定一覧_詳細」画面に戻る
     */
    previous() {
      let route = this.$route.query.routeName
      this.$router.push({
        name: route,
        params: {
          checkListDate: this.report.scheduledDate,
          userId: this.report.insertUser,
          name: this.report.updateUserName
        },
        query: {
          checkList: 'true'
        }
      })
    },
  }
}
</script>

<style scoped>
.main-form {
  /* min-height: 2000px !important; */
  min-width: 770px !important;
  /* height: 100vh !important; */
}

.edit-main-form {
  /* min-height: 2000px !important; */
  min-width: 860px !important;
  /* height: 100vh !important; */
}

.pc-h {
  height: calc(100dvh - 139px);
}

.add-btn {
  background: lightseagreen;
  border-color: #3a623e;
}

.add-btn:hover {
  background: lightseagreen;
  border-color: #3a623e;
}

.color-btn {
  background: #f68f42;
  border-color: #f68f42;
}

.color-btn:hover {
  background: #f68f42;
  border-color: #f68f42;
}

.file-type {
  opacity: 0;
  position: absolute;
  top: 0;
  width: 49%;
}

.file-type2 {
  opacity: 0;
  position: absolute;
  top: 0;
  width: 98%;
}

.drag-photo {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 100;
}

.photo-not {
  position: absolute;
  left: 5%;
  top: 45%;
}

.photo-info-only {
  position: absolute;
  left: 40%;
  top: 42%;
}

.photo-info {
  position: absolute;
  left: 65%;
  top: 42%;
}

.photo-info2 {
  position: absolute;
  left: 15%;
  top: 42%;
}

.retouch {
  writing-mode: vertical-rl;
  height: 136px;
  width: 42px;
  background: #d3e9f8;
}

.retouch-top {
  border-style: solid;
  border-width: 0 0 42px 42px;
  border-color: transparent transparent #d3e9f8 transparent;
}

.retouch-bot {
  border-style: solid;
  border-width: 0 42px 42px 0;
  border-color: transparent #d3e9f8 transparent transparent;
}

</style>